$(function () {
    let countryData = window.intlTelInputGlobals.getCountryData(),
        telInput = $("#phone"),
        countries = $("#country_code");

    telInput.intlTelInput(telInput, {
        nationalMode: true,
        utilsScript: require('intl-tel-input/build/js/utils')
    });

    $.each(countryData, function (i, country) {
        countries.append($("<option></option>").attr("value", country.iso2).text(country.name));
    });

    let initialCountry = telInput.intlTelInput("getSelectedCountryData").iso2;
    countries.val(initialCountry);


    telInput.on("countrychange", function () {
        countries.val(telInput.intlTelInput("getSelectedCountryData").iso2);
        countries.trigger('change');
    });

    countries.change(function () {
        telInput.intlTelInput("setCountry", $(this).val());
        telInput.valid()
    });

    jQuery.validator.addMethod("validPhone", function () {
        return telInput.intlTelInput("isValidNumber");
    }, 'Please enter a valid phone number.');

    $("#registerForm").validate({
        rules: {
            name: { required: true, maxlength: 255 },
            email: { required: true, email: true, maxlength: 255 },
            phone: { required: true, validPhone: true },
            country_code: { required: true },
            password: { required: true, minlength: 8 },
            password_confirmation: { required: true, equalTo: "#password" }
        },
        messages: {
            country_code: { required: "Please select a country." },
            phone: { required: "Please enter your phone number." }
        },
        submitHandler: function (form) {
            var $btn = $(form).find('button[type="submit"], input[type="submit"]');
            if ($btn.prop('disabled')) {
                return false;
            }
            $btn.prop('disabled', true).addClass('disabled');
            $("#phone_number").val(telInput.intlTelInput("getNumber"));
            form.submit();
        }
    });
});